import { useRoute } from '#imports'
import { ref, watch } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { useRequests } from './useRequests'

function useFetchRatingDistribution() {
  const route = useRoute()

  const requests = useRequests()

  if (!requests || !('getRatingDistribution' in requests))
    return { data: ref(), error: ref() }

  return useHttpFetch(requests.getRatingDistribution, {
    pathParams: route.params,
  })
}

export function useRatingDistribution() {
  const route = useRoute()
  const logger = useLogger()

  const { data: ratingDistributionResponse, error } =
    useFetchRatingDistribution()

  watch(
    error,
    () => {
      if (error.value instanceof Error) {
        logger.error(`[REVIEWS][${route.name?.toString()}]`, {
          error: error.value,
        })
      }
    },
    { immediate: true },
  )

  return {
    ratingDistributionResponse,
  }
}
